<div normal>
    <modal-default-mmaxapp>
            <div class="tarjetaconfirmar">
                <div class="titulo">
                        Retiro en Sucursal
                </div>
                <div class="leyendaconfirmar">
                        {{retiroSucursal}}
                </div>
                <div class="botones">
                        <button class="buttonpc whibutton" (click)="aceptar()">Aceptar</button>
                </div>
            </div>
    </modal-default-mmaxapp>
</div>